export interface Attendee {
  age?: number;
  hasAttended: boolean;
  name: string;
}

export interface AttendeeGroup {
  adults: Attendee[];
  children: Attendee[];
}

export function splitByAge(
  attendees: Attendee[],
  majority: number
): AttendeeGroup {
  const adults = [];
  const children = [];

  attendees?.forEach((attendee) => {
    if (majority <= attendee.age) {
      adults.push(attendee);
    } else {
      children.push(attendee);
    }
  });

  return {
    adults,
    children,
  };
}
